export default "__VITE_ASSET__DuTljqQ4__"